<template>
  <div>
    <el-table :data="data" border height="100%" style="width: 100%">
      <el-table-column prop="staff" label="维护人员" :width="180">
      </el-table-column>
      <el-table-column prop="m_time" label="维护时间" :width="180">
      </el-table-column>
      <el-table-column prop="detail" label="维护说明">
      </el-table-column>
    </el-table>
    <div>
      <el-button type="text" icon="el-icon-circle-plus" @click="addMaintainRd">添加维护记录</el-button>
      <Pagination style="margin-top:-30px;" totalCountOrURL="/terminal/cnt_deviceMaintainRd" :params="{device_lgid:lgid}"
        @change="handlePageChange">
      </Pagination>
    </div>
    <el-dialog :visible.sync="editShow" width="520px" title="添加维护记录">
      <el-form label-width="80px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="维护人员">
              <el-input v-model="form.staff"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item label="维护时间">
              <el-date-picker v-model="form.m_time" type="datetime" placeholder="选择日期时间" style="width:100%;" format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="维护说明">
          <el-input type="textarea" :rows="2" v-model="form.detail" placeholder="问题类型、现场情况、维护结果等"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom:0;">
          <i style="float:left;margin-left:-80px;">{{`（设备：${lgid}）`}}</i>
          <el-button style="float:right;" type="primary" @click="save">保 存</el-button>
          <el-button style="float:right;margin-right:5px;" @click="editShow = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Pagination from "@/components/PageNations/Pagination";
  export default {
    props: ["lgid"],
    components: {
      Pagination
    },
    mounted() {
      this.getData();
    },
    watch: {
      lgid() {
        this.getData();
      }
    },
    data() {
      return {
        data: [],
        page: 1,
        size: 10,
        editShow: false,
        form: {
          staff: "",
          m_time: "",
          detail: ""
        }
      };
    },
    methods: {
      handlePageChange(params) {
        this.page = params.page;
        this.size = params.size;
        this.getData();
      },
      getData() {
        if (this.lgid) {
          this.$getJSON("/terminal/s_deviceMaintainRd", {
            device_lgid: this.lgid,
            page: this.page,
            size: this.size
          }).then(res => {
            this.data = res.data;
          });
        }
      },
      addMaintainRd() {
        this.form = {};
        this.form.device_lgid = this.lgid;
        this.editShow = true;
      },
      save() {
        if (!this.form.staff || (this.form.staff = this.form.staff.trim()) === "") {
          this.$message.error("维护人员不能为空");
          return;
        }
        if (!this.form.m_time || (this.form.m_time = this.form.m_time.trim()) === "") {
          this.$message.error("时间不能为空");
          return;
        }
        if (!this.form.detail || (this.form.detail = this.form.detail.trim()) === "") {
          this.$message.error("说明不能为空");
          return;
        }
        this.$confirm("确认添加维护记录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.editShow = false;
          this.$getJSON("/terminal/i_deviceMaintainRd", this.form).then(res => {
            this.$message.success("添加成功");
            this.getData();
          });
        }).catch(() => {});
      }
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Tables/DeviceMaintainRd.vue